import { defineMessages, useIntl } from 'react-intl';

import { useContentfulContentTypeEntry } from '@order/Contentful';
import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * Returns a trademark when the feature flag is enabled.
 * @see {@link https://app.contentful.com/spaces/wme4s8lvzccr/entries/lUNJYtwwtNw2B9S549Bug?focusedField=trademark}
 */
export const useTrademark = () => {
  const { formatMessage } = useIntl();

  const shouldIncludeTrademark = useFeatureFlag('cels-4044-enable-trademark');

  const { data } = useContentfulContentTypeEntry<ContentfulOrganizationLinksFooter>({
    contentType: CONTENT_TYPE,
  });

  const trademark = data?.fields?.trademark ?? formatMessage(messages.trademark);

  return shouldIncludeTrademark ? trademark : undefined;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CONTENT_TYPE = 'organizationLinksFooter';

// ─── Types ───────────────────────────────────────────────────────────────────

type ContentfulOrganizationLinksFooter = Readonly<{
  trademark?: string;
}>;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  trademark: {
    defaultMessage: 'Sweetgreen® and the Hex Bowl™ are trademarks of Sweetgreen, Inc.',
    description: 'Trademark | Fallback',
  },
});
